import React from "react";
import { Link, NavLink } from "react-router-dom";
import { MdOutlineCancel } from "react-icons/md";
import { links } from "./SidebarItem";
import { useStateContext } from "../contexts/ContextProvider";

export const BrandLogo = () => (
  <span className="flex items-center gap-2 text-xl font-extrabold tracking-tight text-slate-900 dark:text-white">
    <img src={`${process.env.PUBLIC_URL}/favicon.svg`} alt="" className="w-8 h-8" />
    <span>
      Bid<span style={{ color: "var(--accent)" }}>Pulse</span>
    </span>
  </span>
);

const Sidebar = () => {
  const { activeMenu, setActiveMenu, screenSize, currentColor } =
    useStateContext();

  const handleCloseSidebar = () => {
    if (activeMenu && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const baseLink =
    "flex items-center gap-3 px-3 py-2 mx-3 my-0.5 rounded-lg text-sm font-medium transition-colors [&>svg]:text-lg [&>svg]:shrink-0";
  const activeLink = `${baseLink} text-white shadow-sm`;
  const normalLink = `${baseLink} text-gray-600 dark:text-gray-300 hover:bg-light-gray hover:text-gray-900 dark:hover:text-black`;

  if (!activeMenu) return null;

  return (
    <div className="h-screen flex flex-col">
      <div className="flex justify-between items-center h-16 px-5 shrink-0 border-b border-gray-100">
        <Link to="/" onClick={handleCloseSidebar}>
          <BrandLogo />
        </Link>
        <button
          type="button"
          aria-label="Close menu"
          onClick={() => setActiveMenu(false)}
          className="text-xl rounded-full p-2 hover:bg-light-gray md:hidden"
        >
          <MdOutlineCancel />
        </button>
      </div>
      <nav className="flex-1 overflow-y-auto py-3">
        {links.map((item) => (
          <div key={item.title} className="mb-2">
            <p className="px-6 pt-3 pb-1 text-[11px] font-semibold uppercase tracking-wider text-gray-400">
              {item.title}
            </p>
            {item.links.map((link) => (
              <NavLink
                to={`/${link.path}`}
                key={link.path}
                onClick={handleCloseSidebar}
                style={({ isActive }) => ({
                  backgroundColor: isActive ? currentColor : "",
                })}
                className={({ isActive }) => (isActive ? activeLink : normalLink)}
              >
                {link.icon}
                <span className="capitalize">{link.name}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
